import { Gender } from '@trialcard/enums';

export default [
    { id: Gender.M, name: 'Male', code: Gender[Gender.M] },
    { id: Gender.F, name: 'Female', code: Gender[Gender.F] },
    //{ id: Gender.UNKN, name: 'Prefer Not to Answer', code: Gender[Gender.UNKN] },
    //{ id: Gender.I, name: 'Other', code: Gender[Gender.I] },
    { id: Gender.PNTA, name: 'Prefer not to answer', code: Gender[Gender.PNTA] },
];
